import ReactTableBase from "../../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressBook,
    faMailBulk,
    faMapPin,
    faMessage,
    faPhone,
    faSms
} from "@fortawesome/free-solid-svg-icons";
import RenderCellSplit from "../../Table/RenderCellSplit";
import {getLabel} from "../../../services/LabelService";
import DateService from "../../../services/DateService";

const CrmUserHistoryTable = ({ crmUserHistory, serverSideSorting = false, onSortChange, initialSortBy }) => {
    const data = React.useMemo(() => crmUserHistory, [crmUserHistory]);

    const renderCellDateHeure = ({ value }) => {
        if (!value) return;
        return DateService.formatDate(value);
    }

    const renderCellDetail = ({ value, row }) => {
        return (
            <div>
                <div style={{ padding: "4px", display: "flex", flexDirection: "row" }}>
                <span style={{ marginRight: "4px" }}>
                    <FontAwesomeIcon
                        title={"Destinataire"}
                        icon={row.original.canal_send === "sms" ? faPhone : faAddressBook}
                    />
                </span>
                    <span>
                    {value?.to ? (
                        row.original.canal_send === "email" ? (
                        <ul style={{ padding: 0, listStyle: "none", margin: 0 }}>
                            {value.to.map((recipient, index) => (
                                <li key={index}>
                                    <span>{recipient.Name}</span> - {recipient.Email}
                                </li>
                            ))}
                        </ul>
                    ) : value.to) : (
                        <span style={{
                            fontSize: "0.8em",
                            fontStyle: "italic",
                            color: "#6e6e6e"
                        }}>Pas de données</span>
                    )}
                </span>
                </div>

                {value?.subject && (
                    <div title={"Objet"} style={{ padding: "4px", display: "flex", flexDirection: "row" }}>
                    <span style={{ marginRight: "4px" }}>
                        <FontAwesomeIcon icon={faMapPin} title={"Objet"} />
                    </span>
                        <span>{value.subject}</span>
                    </div>
                )}

                <div style={{ padding: "4px", display: "flex", flexDirection: "row" }}>
                <span style={{ marginRight: "4px" }}>
                    <FontAwesomeIcon icon={faMessage} title={"Message"} />
                </span>
                    <span>
                    {value?.message ? (
                        RenderCellSplit({ value: value.message, maxLength: 300 })
                    ) : (
                        <span style={{
                            fontSize: "0.8em",
                            fontStyle: "italic",
                            color: "#6e6e6e"
                        }}>Pas de données</span>
                    )}
                </span>
                </div>
            </div>
        );
    };

    const columns = [
        /*{
            Header: 'ID',
            accessor: 'id',
        },*/
        {
            Header: 'Canal',
            accessor: 'canal_send',
            Cell: ({ value, row }) => {
                let color = row.original.actif === true ? "var(--clr-success)" : "var(--clr-danger)";
                let icone = row.original.canal_send === "sms" ? faSms : faMailBulk;
                return <span style={{ color: `${color}`, fontWeight: "600"  }} title={row.original.actif ? "Actif" : "Inactif"}><FontAwesomeIcon icon={icone} /> { getLabel(value) }</span>;
            }
        },
        {
            Header: 'Type',
            accessor: 'type',
            Cell: ({ value, row }) => {
                return <span style={{ wordWrap: "break-word" }} title={row.original.actif ? "Actif" : "Inactif"}>{ getLabel(value) }</span>;
            }
        },
        {
            Header: 'Utilisateur',
            accessor: 'user',
            Cell: ({ value }) => <Link to={`/admin/utilisateurs/${value.id}`}>{value.nom} {value.prenom}</Link>,
        },
        /*
        {
            Header: 'API ref',
            accessor: 'campaign_api_id',
        },
        */
        {
            Header: 'Envoi',
            accessor: 'date_send',
            Cell: renderCellDateHeure,
        },
        /*
        {
            Header: 'Créé',
            accessor: 'created_at',
            Cell: renderCellDateHeure,
        },
        */
        {
            Header: 'Dernière modification',
            accessor: 'updated_at',
            Cell: renderCellDateHeure,
        },
        /*
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: renderCellActif,
        },
        */
        {
            Header: 'Détail',
            accessor: 'detail',
            Cell: renderCellDetail,
        }
    ];

    return (
        <ReactTableBase
            dataSource={crmUserHistory}
            columnsData={columns}
            serverSideSorting={serverSideSorting}
            initialSortBy={initialSortBy}
            onSortChange={onSortChange}
        />
    );
}

export default CrmUserHistoryTable;